import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowRight, CaretLeft } from "@phosphor-icons/react";
import { getPost } from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null); setNotFound(false);
    getPost(slug).then(setPost).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="pt-40 pb-40 text-center">
        <p className="text-navy font-heading text-2xl">Article not found.</p>
        <Link to="/blog" className="text-gold font-semibold mt-4 inline-block">Back to blog</Link>
      </div>
    );
  }

  if (!post) return <div className="pt-40 pb-40 text-center text-brand-slate">Loading…</div>;

  return (
    <article data-testid="blog-post" className="bg-warm-white">
      <section className="bg-navy grain relative pt-[120px] pb-16 lg:pt-[150px] lg:pb-20">
        <div className="relative z-10 max-w-3xl mx-auto px-5 sm:px-8">
          <Link to="/blog" data-testid="post-back"
            className="inline-flex items-center gap-1.5 text-light-slate hover:text-warm-white text-sm mb-8 transition-colors">
            <CaretLeft size={16} /> All articles
          </Link>
          <p className="eyebrow text-gold mb-4">{post.category}</p>
          <h1 className="font-heading font-extrabold tracking-tighter text-warm-white text-[clamp(2rem,5vw,3.6rem)] leading-[1.02]">
            {post.title}
          </h1>
          <p className="mt-5 text-light-slate text-sm">{post.read_time} · {post.date}</p>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          {post.body?.map((block, i) =>
            block.type === "h" ? (
              <h2 key={i} className="font-heading font-bold text-navy text-2xl mt-10 mb-3">{block.text}</h2>
            ) : (
              <p key={i} className="text-brand-slate text-lg leading-relaxed mb-5">{block.text}</p>
            )
          )}

          <div className="mt-14 rounded-2xl bg-navy grain relative overflow-hidden p-8 sm:p-10">
            <div className="pointer-events-none absolute -top-16 -right-16 w-52 h-52 rounded-full bg-gold/10 blur-2xl" />
            <div className="relative z-10">
              <h3 className="font-heading font-extrabold text-warm-white text-2xl">Have questions about your situation?</h3>
              <p className="text-light-slate mt-3">Book a free 15-minute call with a licensed agent — no pressure, no cost.</p>
              <Link to="/" state={{ scrollTo: "booking" }} data-testid="post-cta"
                className="mt-6 group inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3.5 text-navy font-semibold hover:brightness-110 transition-all">
                Book a consultation
                <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </article>
  );
}
